// extracted by mini-css-extract-plugin
export default {"account":"account-info_account__PWxls","hideAccount":"account-info_hideAccount__Ah1Zp","account_logo":"account-info_account_logo__i2SuG","btn_exit":"account-info_btn_exit__RGFoT"};